import "./about.css";

import React from "react";

import { ABOUT } from "../../data/content";
import { SECTIONS } from "../../utils/stateTypes";
import Reveal from "../general/Reveal";
import SectionHeading from "../general/SectionHeading";

//Shapes graphic from the original site
const AboutShapes = () => (
  <svg
    className={"about-shapes"}
    viewBox={"47 20 106.766 160.148"}
    xmlns={"http://www.w3.org/2000/svg"}
    aria-hidden={"true"}
  >
    <path
      fill={"#76747B"}
      fillRule={"evenodd"}
      d={"M47 126.765h53.383v53.383H77.245C60.541 180.148 47 167.156 47 151.129v-24.364Z"}
    />
    <path
      fill={"#EBECF3"}
      fillRule={"evenodd"}
      d={"M153.766 73.383h-53.383V20h23.137c16.704 0 30.246 12.992 30.246 29.019v24.364Z"}
    />
    <path
      fill={"#BBBDC8"}
      fillRule={"evenodd"}
      d={"M47 46.691C47 31.951 58.95 20 73.691 20c14.742 0 26.692 11.95 26.692 26.691v53.383c0 14.741-11.95 26.692-26.692 26.692-14.74 0-26.691-11.951-26.691-26.692 0-14.737 11.944-26.685 26.68-26.691C58.942 73.376 47 61.429 47 46.69Zm80.087 80.075c14.735-.007 26.679-11.955 26.679-26.692 0-14.741-11.951-26.691-26.692-26.691h-26.691v26.691c0 14.735 11.939 26.68 26.671 26.692h-26.671v26.691c0 14.741 11.95 26.691 26.691 26.691s26.692-11.950 26.692-26.691c0-14.737-11.944-26.685-26.679-26.691Z"}
    />
  </svg>
);

const About = () => {
  return (
    <section
      id={SECTIONS.ABOUT}
      className={"section about"}
    >
      <div className={"container about-grid"}>
        <SectionHeading
          className={"about-heading"}
          tag={ABOUT.tag}
          title={ABOUT.title}
        />

        <div className={"about-text"}>
          {ABOUT.paragraphs.map((paragraph, i) => (
            <p key={i}>{paragraph}</p>
          ))}
        </div>

        <Reveal
          className={"about-art"}
          variant={"fade"}
        >
          <AboutShapes />
        </Reveal>
      </div>
    </section>
  );
};

export default About;
